// ExpandableCell.tsx
import React, { useState } from 'react';
import { Link, SpaceBetween } from '@amzn/awsui-components-console';
import CopyToClipboard from '@amzn/awsui-components-console/copy-to-clipboard';
import { useTranslation } from 'src/i18n/shim/useTranslation';

interface ExpandableCellProps {
  text: string | undefined;
  maxVisible?: number;
}

const ExpandableCell: React.FC<ExpandableCellProps> = ({
  text,
  maxVisible = 20,
}) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  if (!text || text.length === 0) return <>—</>;
  if (text.length <= maxVisible) return <>{text}</>;

  const displayed = expanded ? text : text.slice(0, maxVisible);

  return (
    <SpaceBetween size="xxs" direction="horizontal">
      <CopyToClipboard
        variant="inline"
        copyErrorText={t('cell-anchor-copy-failed')}
        copySuccessText={t('cell-anchor-copied')}
        textToDisplay={displayed}
        textToCopy={text}
      />
      <Link
        onFollow={(e) => {
          e.preventDefault();
          setExpanded(!expanded);
        }}
        variant="info"
      >
        {expanded ? t('cell-show-less') : t('cell-show-more')}
      </Link>
    </SpaceBetween>
  );
};

export default ExpandableCell;
